export default "__VITE_PUBLIC_ASSET__bfa18b49__"